import { render, staticRenderFns } from "./LocalHostForm.vue?vue&type=template&id=21212498"
import script from "./LocalHostForm.vue?vue&type=script&lang=js"
export * from "./LocalHostForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports